import { api, ReactQueryOptions } from '@api'
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate'
import { gtagEventTrigger } from '@specs/helpers'
import { useShowToast } from '@hooks/useShowToast'

type useEarnDropOptions = ReactQueryOptions['DropManager']['earn']

export const useEarnDrop = (toyId: number, idempotencyKey?: number, options?: useEarnDropOptions) => {
    const { onSuccess } = options ?? {}
    const utils = api.useContext()
    const { showToast } = useShowToast()
    const { updateFigurineData, updateSpaceCollectionsData, updateStoreItemsData } = useInvalidate()

    return api.DropManager.earn.useMutation({
        ...options,
        mutationKey: ['DropManager.earn', { toyId, idempotencyKey }],
        onError: () => {
            showToast({ variant: 'error', text: 'error.default' })
        },
        onSuccess: async (data, variables, context) => {
            await onSuccess?.(data, variables, context)
            if (data.status === 'success') {
                gtagEventTrigger({ action: 'adding_to_collection', category: 'commerce' })
                updateFigurineData({ toyId })
                updateStoreItemsData({ toyId })

                const toy = await utils.ToyManager.getSingle.fetch({ id: toyId })
                if (!toy) return
                updateSpaceCollectionsData({ collections: toy.collections.map((collection) => collection.collectionid) })
            }else {
                showToast({ variant: 'error', text: data.code })
            }
        },
    })
}
